import { useState } from "react";
import Layout from "../../../Containers/Layout";
import styles from "./DisciplineGroupForm.module.scss";
import { Form, DatePicker, Select, Radio, Col, Row, Input } from "antd";
import CustomForm from "../../../CustomComponents/CustomForm";
import { theme } from "../../../theme";
import { Redirect, useLocation, useParams } from "react-router-dom";
import {
  NOTIFICATION_TYPES,
  openNotification,
} from "../../Notifications/NotificationsUtils";
import { getUserId } from "../../../utils/utilFunctions";
import ConfirmationModal from "../../../Containers/ConfirmationModal";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import useDebounce from "../../../Hooks/debounce";
import { getDomain, getFundamentalDomains, getScienceBranches, updateDomain } from "../../../Requests/domain-requests";
import { DisciplineGroupTypeEnum, SemesterTypeEnum, SimpleStudyCycleEnum, StudyCycleEnum, StudyYearEnum } from "../../../Api";
import { addDomain } from "../../../Requests/domain-requests";
import { getFaculties } from "../../../Requests/faculty-requests";
import { addDisciplineGroup, getDisciplineGroup, updateDisciplineGroup } from "../../../Requests/discipline-group-requests";

const { RangePicker } = DatePicker;
const { Group } = Radio;
const { Option } = Select;
const dateFormatList = "YYYY-MM-DD";


const DisciplineGroupForm = (props: any) => {
  const { t, i18n } = useTranslation();

  const openGetErrorNotification = (_error: any) => {
    openNotification(
      'Eroare',
      'Datele nu au putut fi aduse din server!',
      NOTIFICATION_TYPES.ERROR
    );
  };

  const currentUserId = getUserId();

  const [redirect, setRedirect] = useState(false);

  const [form] = Form.useForm<{
    name: string | null,
    type: DisciplineGroupTypeEnum,
    studyYear: StudyYearEnum,
    semester: SemesterTypeEnum,
    disiplineCount: number,
  }>();

  const { disciplineGroupId } = useParams<{ disciplineGroupId: string }>();
  const location = useLocation();
  const studyPlanId = (location.state as any).studyPlanId;
  const studyCycle = (location.state as any).studyPlanCycle as SimpleStudyCycleEnum;

  const { data: disciplineGroup } = useQuery(["getDisciplineGroup", disciplineGroupId], () => getDisciplineGroup(disciplineGroupId), {
    onError: (err) => {
      openGetErrorNotification(err);
    },
    onSuccess: (data) => {
      if (data) {
        form.setFieldsValue({
            name: data.name,
            disiplineCount: data.disiplineCount,
            type: data.type,
            studyYear: data.studyYear,
            semester: data.semester
        });

      }
    },
    refetchOnWindowFocus: false
  });

  const openSaveErrorNotification = (error: any) => {
    if (error.status === 400) {
      openNotification(
        'Eroare!',
        'Datele completate nu sunt valide!',
        NOTIFICATION_TYPES.ERROR
      );
    } else {
      openNotification(
        'Eroare!',
        'Propunerea nu a putut fi salvată!',
        NOTIFICATION_TYPES.ERROR
      );
    }
  };

  const handleCancel = () => {
    setRedirect(true);
  };

  const openSuccessNotificationAndRedirect = () => {
    setRedirect(true);
    openNotification(
      'Succes!',
      'Salvarea s-a efectuat cu succes!',
      NOTIFICATION_TYPES.SUCCESS,
      6
    );
  } 

  const handleSave = () => {
    const state = form.getFieldsValue();
    console.warn(state);
    
   //TODO validation
    if (state.name !== "") {
      let obj = {
        name: state.name!,
        type: state.type,
        disiplineCount: state.disiplineCount,
        semester: state.semester,
        studyYear: state.studyYear,
        studyPlanId: studyPlanId
      };
      (disciplineGroupId ? updateDisciplineGroup(disciplineGroupId, obj) : addDisciplineGroup(obj))
      .then(openSuccessNotificationAndRedirect)
      .catch(openSaveErrorNotification);
    } else {
      openNotification(
        'Eroare!',
        'Datele introduse nu sunt valide!',
        NOTIFICATION_TYPES.ERROR
      );
    }
  };
  

  if (redirect) {
    return <Redirect to={{pathname: "/grupuriDiscipline/" + studyPlanId}} />;
  } else {
    return (
      <Layout>
        <div className={styles.container}>
          <CustomForm
            form={form}
            layout={theme.layout}
            action="/domenii"
            boxshadow={"none"}
          >
            <div className={styles.firstLine}>    

              <Row gutter={8}>
                <Col span={24}>
                  <Form.Item
                    name='name'
                    label='Denumirea grupului:'
                    rules={[
                      {
                        required: true,
                        message: 'Denumirea grupului este obligatorie!',
                        whitespace: true,
                      },
                    ]}
                    >
                    <Input
                      placeholder='Completează denumirea grupului de studii'
                      />
                  </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                      name='type'
                      label='Tip:'
                      rules={[
                        {
                          required: true,
                          message: 'Selectarea tipului de grup este obligatorie!',
                          whitespace: false,
                        },
                      ]}
                    >
                      <Select
                        // allowClear
                        style={{ width: "100%", textAlign: "left" }}
                        placeholder='Alege tipul grupului'
                      >
                          <Option key={DisciplineGroupTypeEnum.DisciplineGroup}>Grup Discipline</Option>
                          <Option key={DisciplineGroupTypeEnum.PackGroup}>Grup Pachete</Option>
                      </Select>
                    </Form.Item>
                </Col>
                
                <Col span={6}>
                  <Form.Item
                    name='disiplineCount'
                    label='Număr discipline:'
                    rules={[
                      {
                        required: true,
                        message: 'Numărul de discipline este obligatoriu!',
                      },
                    ]}
                  >
                    <Input placeholder='Ex: 2' />
                  </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                      name='studyYear'
                      label='An de studiu:'
                      rules={[
                        {
                          required: true,
                          message: 'Selectarea anului de studiu este obligatorie!',
                          whitespace: false,
                          
                        },
                      ]}
                    >
                      <Select
                        // allowClear
                        style={{ width: "100%", textAlign: "left" }}
                        placeholder='Ciclul de învățământ'
                      >
                        {
                        studyCycle === SimpleStudyCycleEnum.Bachelor ?
                        [
                          <Option value={StudyYearEnum.L1}>Licență 1</Option>,
                          <Option value={StudyYearEnum.L2}>Licență 2</Option>,
                          <Option value={StudyYearEnum.L3}>Licență 3</Option>,
                          <Option value={StudyYearEnum.L4}>Licență 4</Option>
                        ] :
                        [
                          <Option value={StudyYearEnum.M1}>Masterat 1</Option>, 
                          <Option value={StudyYearEnum.M2}>Masterat 2</Option>
                        ]
                        } 
                        
                      </Select>
                    </Form.Item>
                </Col>
                

                <Col span={6}>
                    <Form.Item
                      name='semester'
                      label='Semestru:'
                      rules={[
                        {
                          required: true,
                          message: 'Selectarea semestrului este obligatorie!',
                          whitespace: false,
                        },
                      ]}
                    >
                      <Select
                        // allowClear
                        style={{ width: "100%", textAlign: "left" }}
                        placeholder='Alege semestrul'
                      >
                            <Option key={SemesterTypeEnum.S1}>Semestrul I</Option>
                            <Option key={SemesterTypeEnum.S2}>Semestrul II</Option>
                      </Select>
                    </Form.Item>
                </Col>
              </Row>
            </div>
            <div className={styles.secondLine}>
              <div className={styles.firstColumn}>
                <ConfirmationModal
                  nameButton={t('internships.addInternshipForm.cancel')}
                  modalText={t('internships.cancelMessage')}
                  titleButton={''}
                  handleFunction={handleCancel}
                  iconButton={null}
                  shapeButton={''}
                  typeButton={''}
                  disabledProp={false}
                  styleProp={{ background: theme.green, color: theme.white, marginRight: '10%', marginTop: '0%', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px' }}
                />
                <ConfirmationModal
                  nameButton={disciplineGroupId ? t('internships.addInternshipForm.updateButton') : t('internships.addInternshipForm.saveButton')}
                  modalText={t('internships.saveMessage')}
                  titleButton={''}
                  handleFunction={handleSave}
                  iconButton={null}
                  shapeButton={''}
                  typeButton={''}
                  disabledProp={false}
                  styleProp={{ background: theme.secondColor, color: theme.white, marginRight: '10%', marginTop: '0%', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px' }}
                />
              </div>
            </div>
          </CustomForm>
        </div>
      </Layout>
    );
  }
};

export default DisciplineGroupForm;
